export interface CountryCode {
  code: string;
  name: string;
}

export const COUNTRY_CODES: CountryCode[] = [
  { code: '+91', name: 'IN' },
  { code: '+1', name: 'US/CA' },
  { code: '+44', name: 'UK' },
  { code: '+61', name: 'AU' },
  { code: '+971', name: 'AE' },
  { code: '+65', name: 'SG' },
  { code: '+60', name: 'MY' },
  { code: '+66', name: 'TH' },
  { code: '+49', name: 'DE' },
  { code: '+33', name: 'FR' },
];

export const DEFAULT_COUNTRY_CODE = '+91';

/** Splits a stored full phone number (e.g. "919876543210") into country code and local digits. */
export function splitPhone(full: string): { countryCode: string; localNumber: string } {
  for (const c of COUNTRY_CODES) {
    const digits = c.code.replace('+', '');
    if (full.startsWith(digits)) return { countryCode: c.code, localNumber: full.slice(digits.length) };
  }
  return { countryCode: DEFAULT_COUNTRY_CODE, localNumber: full };
}

/** Assembles a full phone number from a country code (e.g. "+91") and local digits. */
export function assemblePhone(countryCode: string, localNumber: string): string {
  return `${countryCode.replace('+', '')}${localNumber.trim()}`;
}
